import { clone } from "lodash";
import {
  RECEIVE_SERVER_MESSAGE,
  DISMISS_SERVER_MESSAGE,
  RESET_SERVER_MESSAGE,
} from "./ServerMessageActions";

const serverMessagesReducer = (state = [], payload = {}) => {
  const { type, message } = payload;
  const newState = clone(state);
  let i;
  switch (type) {
    case RECEIVE_SERVER_MESSAGE:
      i = newState.indexOf(message);
      if (i === -1) newState.push(message);
      return newState;
    case DISMISS_SERVER_MESSAGE:
      i = newState.indexOf(message);
      if (i !== -1) newState.splice(i, 1);
      return newState;
    case RESET_SERVER_MESSAGE:
      return [];
    default:
      return state;
  }
};

export default serverMessagesReducer;
